module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-15.64e834f8.png";